import logo from './logo.svg';
import './App.css';
import Header from "./components/Header";
import MainView from "./components/MainView";
import {BrowserRouter, Route} from "react-router-dom";
import About from "./components/About";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import {useEffect, useState} from "react";
import Loading from "./components/Loading";



function App() {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const timeId = setTimeout(() => {
            setLoading(true)
        }, 3000)
        return () => {
            clearTimeout(timeId)
        }
    },[loading])
  return (
      <>
          { !loading ? <Loading/> : <div>
                  <BrowserRouter>
                      <Header/>
                      <Route path={'/'} exact component={MainView}/>
                      <Route path={'/about'} exact component={About}/>
                      <Route path={'/experience'} exact component={Experience}/>
                      <Route path={'/contact'} exact component={Contact}/>
                      <Footer/>
                  </BrowserRouter>

              </div>
          }
      </>
  );
}

export default App;
